import { render } from "./DropdownMultipleTag.vue?vue&type=template&id=e46f716e&scoped=true"
import script from "./DropdownMultipleTag.vue?vue&type=script&lang=js"
export * from "./DropdownMultipleTag.vue?vue&type=script&lang=js"

import "./DropdownMultipleTag.vue?vue&type=style&index=0&id=e46f716e&lang=scss&scoped=true"

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e46f716e"]])

export default __exports__